// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__aHhrq","footer":"ModalUpdate_footer__2xRYM"};